import ScalarMenuSection_vue_vue_type_script_setup_true_lang_default from "./ScalarMenuSection.vue.script.js";
//#region src/components/ScalarMenu/ScalarMenuSection.vue
var ScalarMenuSection_default = ScalarMenuSection_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarMenuSection_default as default };

//# sourceMappingURL=ScalarMenuSection.vue.js.map